<template>
    <div>
      <div id="content" class="content animated slideInRight delay-1s">
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-body">
                <div class="row">
                  <div class="col-md-12">
                      <div class="row">

                      <div class="col-md-12" style="text-align:center; font-weight:bold; font-size:20px ">
                        <div class="card-header">
                          <div class="card-title">
                            Usuários contidos no grupo {{ users_groups.title}}:
                          </div>
                        </div>
                      </div>
                    </div>
                    <br>

                    <div class="row">
                        <div class="col-md-6">
                              <button style="background-color:#4b2e8f; border:#4b2e8f" class="btn btn-info btn-block mb-2" @click="moveAll('toNotSelected')">
                                <span class="badge badge-light">{{ selectedUsersFiltered.length }}</span> Mover todos >>
                              </button>
                              <input type="text" placeholder="Procurar..." class="form-control mb-2" v-model="selectedUsers_search" />
                              <ul class="list-group entity-filter-selection">
                                  <li style="background-color:#a6f1a6" class="list-group-item" v-for="(user, index) in selectedUsersFiltered" :key="index" @click="moveUser(user,'toNotSelected')"> {{ user.name }}</li>
                              </ul>
                        </div>

                        <div class="col-md-6">
                            <button style="background-color:#4b2e8f; border:#4b2e8f" class="btn btn-info btn-block mb-2" @click="moveAll('toSelected')">
                              << Mover todos <span class="badge badge-light">{{ usersFiltered.length }}</span> 
                            </button>
                            <input type="text" placeholder="Procurar..." class="form-control mb-2" v-model="users_search" />
                            <ul class="list-group entity-filter-selection">
                                <li style="background-color:#FFCCCB" class="list-group-item" v-for="(user, index) in usersFiltered" :key="index" @click="moveUser(user, 'toSelected')"> {{ user.name }}</li>
                            </ul>
                        </div>
                      </div>
                      <hr />
                      <div class="block text-right">
                        <a class="btn btn-add" @click="save">
                          Salvar
                          <i class="fa fa-save"></i>
                        </a>
                        <router-link to="/users_groups" class="btn btn-back">
                          <i class="fa fa-arrow-left"></i> Voltar
                        </router-link>
                      </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import vSelect from "vue-select";
  
  export default {
    data() {
      return {
        users_search: '',
        users: [],
        usersFiltered: [],
        selectedUsers_search: '',
        selectedUsers: [],
        selectedUsersFiltered: [],
        users_groups: {

        },
      };
    },
    watch: {
    users_search() {
      const self = this;
      if(self.users_search != null){
        self.usersFiltered = [];
        for (var i = 0 ; i < self.users.length ; i++) {
            if (self.users[i].name.toLowerCase().indexOf(self.users_search.toLowerCase()) >= 0 ) {
                self.usersFiltered.push(self.users[i]);
            }
        }
      }
    },
    selectedUsers_search() {
      const self = this;
      if(self.selectedUsers_search != null){
       self.selectedUsersFiltered = [];
       for (var i = 0 ; i < self.selectedUsers.length ; i++) {
           if (self.selectedUsers[i].name.toLowerCase().indexOf(self.selectedUsers_search.toLowerCase()) >= 0 ) {
               self.selectedUsersFiltered.push(self.selectedUsers[i]);
           }
       }
      }
    },
    },
    methods: {
      matchArrays(){
      this.selectedUsersFiltered = this.selectedUsers;
      this.usersFiltered = this.users;
    },
    moveUser(user, method){
      const self = this;

      if(method == "toSelected"){
        self.users.splice(self.users.findIndex(u => u.id === user.id), 1)
        self.selectedUsers.push(user);
      } else {
        self.selectedUsers.splice(self.selectedUsers.findIndex(u => u.id === user.id), 1)
        self.users.push(user);
      }

      self.users_search = null;
      self.selectedUsers_search = null;

      self.matchArrays();

    },
    moveAll(method){
      const self = this;
      if(method == "toSelected"){
        self.selectedUsers = self.selectedUsers.concat(self.users);
        self.users = [];

      } else {
        self.users = self.users.concat(self.selectedUsers);
        self.selectedUsers = [];

      }

      self.matchArrays();

    },
    getUsers: function () {
      const self = this;
      const api = self.$store.state.api + "users";

      self.$http
        .get(api)
        .then((response) => {
          response.data.data.forEach(user => {
            //Se já não estiver selecionado coloca no não selecionado(users)
            if(self.selectedUsers.filter(e => e.id === user.id).length <= 0){
              self.users.push(user);
            }
          });
          self.matchArrays();
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
      makeFormData: function () {
        const self = this;
        let fd = new FormData();
  
        self.selectedUsers.forEach((user, index) => {
        fd.append("users[" + index + "]", user.id);
        });
  
        fd.append("id", self.users_groups.id);
        fd.append("_method", "POST");

        return fd;
      },
      save: function () {
        const self = this;
        let api = self.$store.state.api + "users_groups/editGroupUsers";
  
        let fd = self.makeFormData();

        self.$http
          .post(api, fd)
          .then((response) => {
            self.$message(
              "Sucesso",
              `Usuários do grupo atualizados com sucesso`,
              "success"
            );
            this.$router.push("/users_groups");
          })
          .catch((error) => {
            self.$message(null, error.response.data, "error");
          });
      },
      getUsersGroups: function (id) {
        const self = this;
        const api = self.$store.state.api + "users_groups/" + id + '?with[]=users';
  
        self.$http
          .get(api)
          .then((response) => {
            self.users_groups = response.data.data[0];

            self.selectedUsers = self.users_groups.users;
            self.matchArrays();

            self.getUsers();
          })
          .catch((error) => {
            self.$message(null, error.response.data, "error");
          });
      },
    },
    mounted: function () {
      const self = this;
      let id = self.$route.params.id;
  
      if (id) {
        self.getUsersGroups(id);
      } else {
        self.getUsers();
      }
    },
    components: {
      vSelect,
    },
  };
  </script>
  <style scoped>
  .select {
    height: 10px;
  }
  
  .btn-user:hover,
  .btn-user[aria-expanded="true"] {
    background: linear-gradient(to right, #000, #666);
    color: #fff !important ;
  }

  .list-group-item {
    border-bottom: 2px solid purple
  }

  ul.sortable li.list-group-item {
  padding: 0.4rem 1rem;
  border-radius: 0.25rem;
  border: 1px solid #ccc;
}

ul.sortable li.list-group-item.selected {
  padding: 0.4rem 1rem;
  border-radius: 0.25rem;
  border: 1px solid #ccc;
  background-color: #d5e6ff;
  color: #424241;
}

ul.sortable li.list-group-item i {
  color: #0b033b;
  margin-right: 0;
  margin-top: 4px;
  float: right;
}
.entity-filter-selection {
  max-height: 500px;
  min-height: 100px;
  overflow-y: scroll;
  background-color: white !important;
}

  </style>


// WEBPACK FOOTER //
// src/components/UserGroups/GroupUsers.vue